import { PropertyService, PropertyServiceItem } from "@10x/coreapp/PropertyService";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import ServiceDescriptions from "@my-dld/assets/strings/property_serv_desc";
import { convertTabuPropertyIdRVPropertyType, resetEnv, setEnvUser, setPropertiesOptions } from "./RVUtils";
import { hideLoading, showMessage } from "@my-dld/utils/UIUtils";
import { RVMode, RVSearchType, SearchOption } from "./api/entities";
import { RentalValuationApi as RVApi } from "./api";
import { validateResponse } from "./api/api";
import { Property as XProperty } from "./api/Property";
import { getAppServices } from "@10x/coreapp";
import { showRVPage } from "./NavigationUtils";
import { TabuProfile } from "@10x/sso/TabuProfile";

const RentalValuation: PropertyServiceItem = {
	id: "rental_valuation",
	label: LVStrings.rental_evaluation,
	action: serviceHandler,
	descriptionProvider: ServiceDescriptions,
	allowUnverifiedEmailUsers: false,
};

export function registerPropertyService( propertyService: PropertyService ) {
	// propertyService.registerService(RentalValuation);
}

function serviceHandler( property: any, service: PropertyServiceItem, options?: any ) {
	let propertyTypeId = convertTabuPropertyIdRVPropertyType( property.propertyTypeId );
	if ( propertyTypeId === undefined ) {
		showMessage( Strings.invalid_property_id );
		return;
	}
	const uiService = getAppServices().uiService;
	uiService.showLoading();
	let opt: SearchOption = {
		startIndex: 0,
		maxRows: 10,
		participantId: TabuProfile.getParticipantId(),
		requestorTypeId: RVMode.OWN,
		searchTypeId: RVSearchType.Property,
		propertyTypeId: propertyTypeId!,
		propertyId: property.propertyId + "",
		isFreehold: property.isFreeHold ? 1 : 0,
	} as SearchOption;
	RVApi.searchProperties( opt )
	.then( validateResponse )
	.then( apiResponse => {
		uiService.hideLoading();
		let properties: XProperty[] = apiResponse.PropertiesList ? apiResponse.PropertiesList : [];
		if ( properties.length > 0 ) {
			resetEnv();
			setEnvUser();
			const env = getAppServices().storeService.getStore().getState().RValuation.env;
			env.mode = RVMode.OWN;
			env.propertyType = propertyTypeId;
			setPropertiesOptions( [ properties[ 0 ] ], {
				...opt,
				searchTypeId: RVSearchType.Participant,
			}, env );
			showRVPage();
		} else {
			uiService.showMessage( Strings.invalid_property_id );
		}

	} )
	.catch( reason => {
		hideLoading();
		if ( reason && reason.type && reason.type === "ValidationError" ) {
			uiService.showMessage( reason.message );
		} else {
			uiService.showMessage( reason.toString() );
		}
	} );
}
